// extracted by mini-css-extract-plugin
export default {"icon":"SocialLoginButtons_icon__BzKgR"};